const API_URL = "https://content-planning-scratchpad.onrender.com";
export default API_URL;
